import React from 'react';
import { SimpleImage } from '$partials/media';
import Button from '$partials/ui/button';
import IconDownload from '$partials/icons/icon-download';
import IconExternalLink from '$partials/icons/icon-external-link';
import { formatPublicationDate } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/items.d.ts').ArticleListingItem}
 */

const ArticleListingItem = ({
    className,
    title,
    listingImage,
    listingText,
    parentListingEyebrow,
    publicationDate,
    topics,
    __typename,
    url,
    isCarouselItem = false
}) => {
    const formattedDate = formatPublicationDate(publicationDate);

    return (
        <div
            className={`flex flex-col gap-16 w-full h-full group ${className || ''}`}>
            {/* Property Image */}
            {(listingImage && (__typename !== 'ExternalArticleDetailPage')) && (
                <a
                    className='aspect-[3/2] w-full overflow-hidden relative'
                    href={url}>
                    <SimpleImage
                        {...listingImage}
                        className='w-full h-full object-cover'/>
                    <div className='absolute inset-0 opacity-0 group-hover:opacity-100 before:absolute before:inset-0 before:bg-[rgba(0,0,0,0.4)] before:mix-blend-saturation before:content-[""] after:absolute after:inset-0 after:bg-[rgba(30,37,165,0.5)] after:mix-blend-screen after:content-[""]' />
                </a>
            )}


            {/* Property Details */}
            <div className='flex flex-col w-full flex-1 pr-0 md:pr-40'>
                {/* Details Wrap - Eyebrow and Date */}
                {(parentListingEyebrow || formattedDate) && (
                    <div className='flex gap-8 items-center type-style-eyebrow w-full mb-16'>
                        {parentListingEyebrow && (
                            <p className='text-main-brand-text'>
                                {parentListingEyebrow}
                            </p>
                        )}
                        {parentListingEyebrow && formattedDate && (
                            <p className='text-main-text-primary'>
                                    /
                            </p>
                        )}
                        {formattedDate && (
                            <p className='text-main-text-primary'>
                                {formattedDate}
                            </p>
                        )}
                    </div>
                )}

                {topics?.length > 0 && (__typename !== 'ArticleDetailPage') && (
                    <div className='flex flex-wrap gap-6 w-full mb-16'>
                        {topics.map((topic, index) => (
                            <Button
                                as='a'
                                className='button-tag'
                                href={`/topics/${topic.slug}`}
                                key={index}>
                                <p className='type-style-eyebrow text-tag-main-text'>
                                    {topic.title}
                                </p>
                            </Button>
                        ))}
                    </div>
                )}

                {title && (
                    isCarouselItem ? (
                        <h3 className='type-style-3 text-main-text-primary whitespace-pre-wrap group-hover:text-main-brand-text mb-6'>
                            <Button
                                as='a'
                                href={url}>
                                {title}
                            </Button>
                        </h3>
                    ) : (
                        <Button
                            as='a'
                            className='type-style-3 text-main-text-primary whitespace-pre-wrap group-hover:text-main-brand-text mb-6'
                            href={url}>
                            {title}
                        </Button>
                    )
                )}

                {listingText && (
                    <p
                        className='type-style-body-r text-main-text-primary whitespace-pre-wrap group-hover:text-main-brand-text mb-16'>
                        {listingText}
                    </p>
                )}

                {(topics?.length > 0 && (__typename === 'ArticleDetailPage')) && (
                    <div className='flex flex-wrap gap-6 w-full mb-16'>
                        {topics.map((topic, index) => (
                            <Button
                                as='a'
                                className='button-tag'
                                href={`/topics/${topic.slug}`}
                                key={index}>
                                <p className='type-style-eyebrow text-tag-main-text'>
                                    {topic.title}
                                </p>
                            </Button>
                        ))}
                    </div>
                )}

                <div
                    aria-hidden={true}
                    className='flex-1 block h-full select-none'></div>

                {__typename !== 'ArticleDetailPage' && (
                    <Button
                        as='a'
                        className='h-[44px] w-[44px] button-secondary-filled rounded flex items-center justify-center mt-16'
                        href={url}>
                        {__typename === 'DownloadArticle' ? <IconDownload /> : <IconExternalLink />}
                    </Button>
                )}

            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleListingItem;
